module.exports = __webpack_public_path__ + "assets/faq-illustrations.30b70caf.svg";